import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { Menu } from 'src/app/model/shared/menu';
import { ContentfulService } from 'src/app/service/contentful.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  menu: Menu = {} as Menu;
  socialMenu: Menu = {} as Menu;
  constructor(private contentfulService: ContentfulService, private router: Router) {}

  ngOnInit(): void {
    this.menu.tabs = [];
    this.socialMenu.tabs = [];

    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((event: any) => {
      if (event.url !== '/akamai/sureroute-test-object.html') {
        let query = { 'fields.name': 'Footer Menu' };
        this.contentfulService.getMenuContentWithItems(query).then((menuItems) => {
          this.menu.tabs = menuItems[0]?.fields.jsonData;
        });

        query = { 'fields.name': 'Footer Menu#SOCIAL' };
        this.contentfulService.getMenuContentWithItems(query).then((menuItems) => {
          this.socialMenu.tabs = menuItems[0]?.fields.jsonData;
        });
      }
    });

    // this.mapEntryToFooterMenu(this.menu.tabs)
  }
  // private mapEntryToFooterMenu(tab: Tab[]) {
  //   this.menu.tabs.push({
  //     title: tab.title,
  //     url:tab.url
  //   })
  // }
}
